// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wkq9","importantInfo":"styles_importantInfo__H5LA6"};